// TỈ LỆ THÍCH KHI LƯỚT (X luot_bang_tin, TikTok / YouTube luot_video) — XÁC SUẤT THẬT (người dùng chốt 03/10).
//
// Biểu thức `when` của bước thích trong bundle GIỮ NGUYÊN chữ-từng-chữ như từ khi có khối (755ce79): công thức TẤT ĐỊNH theo vị trí bài
// ("bài thứ k được thích khi (k × tỉ lệ) mod 100 < tỉ lệ" — 10% = mỗi bài thứ 10, 25% = bài 4, 8). Lý do giữ: đổi chữ trong khối → mọi kịch
// bản/mẫu có lướt + thích đổi hash (phải chạy thử lại), còn thêm hàm ngẫu nhiên mới vào biểu thức → bot cũ báo "Hàm không được phép" (phải
// nâng can_plugin). Bot ≤ 0.1.47 vẫn đọc biểu thức như cũ (tất định).
//
// Runner MỚI (src/background/runner.ts whenOk) nhận ra ĐÚNG biểu thức này và hiểu nó là "thích với xác suất = tỉ lệ": MỖI bài hợp lệ được bốc
// độc lập, trúng khi số ngẫu nhiên [0, 100) < tỉ lệ (10% × 9 bài: có lần thích 1, có lần 0 — trung bình 0,9). Phần kẹp tỉ lệ (0..30, chữ → 0)
// lấy từ CHÍNH biểu thức (BT_TI_LE_THICH) nên trần 30% và cách hiểu tham số bị sửa tay vẫn y như cũ. Bộ lọc khác (quảng cáo, đã thích — sổ cái,
// hạn mức ngày, duyệt) KHÔNG đổi: bốc trúng chỉ thay cho "tới lượt theo vị trí".

/** Phần kẹp tỉ lệ (%) trong biểu thức: chữ/rỗng → 0, âm → 0, > 30 → 30. */
export const BT_TI_LE_THICH = "max(min(int(ti_le_thich), 30), 0)";
/** Biểu thức `when` của bước thích khi lướt — KHÔNG ĐỔI (bot cũ đọc tất định; đổi là đổi hash mọi kịch bản có lướt + thích). */
export const DK_THICH_LUOT = `((item._index + 1) * ${BT_TI_LE_THICH}) % 100 < ${BT_TI_LE_THICH}`;

const gon = (s: string): string => s.replace(/\s+/g, "");

/** `when` này có phải điều kiện tỉ lệ thích khi lướt không (so sánh bỏ khoảng trắng — YAML có thể xuống dòng/thụt lề khác). */
export function laDieuKienTiLeThich(when: string | undefined): boolean {
  return typeof when === "string" && gon(when) === gon(DK_THICH_LUOT);
}

/** Bốc MỘT bài: trúng với xác suất phanTram/100. 0 / âm / không phải số → không bao giờ; ≥ 100 → luôn trúng (không tốn số ngẫu nhiên). */
export function bocTheoTiLe(phanTram: number, rnd: () => number): boolean {
  if (!(phanTram > 0)) return false;
  if (phanTram >= 100) return true;
  return rnd() * 100 < phanTram;
}

/**
 * Số ngẫu nhiên có HẠT (mulberry32) — chỉ cho bộ test (Cài đặt ẩn hatNgauNhien): cùng hạt → cùng dãy, để E2E/unit kiểm CHÍNH XÁC bài nào được
 * thích mà không phụ thuộc may rủi. Trả [0, 1).
 */
export function rndTheoHat(hat: number): () => number {
  let a = (Math.trunc(hat) >>> 0) || 0x9e3779b9;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
